import React, { ChangeEvent, FC, useState } from 'react';
import styled from 'styled-components';
import { BasicInput } from '@dev/ee-components';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getCampainCreatorStore, VerifyCampaign } from '@/store/campaignCreator/actions';
import { CampaignErrorNames } from '@/store/campaignCreator/types';
import { SaveInMyTemplatesModalProps } from '../../../../SubjectAndContentInterface';

const ContentWrapper = styled.div`
    & > label {
        margin-top: 16px;
    }
    & > label:first-of-type {
        margin-top: 0;
    }
`;

export const SaveInMyTemplatesModal: FC<SaveInMyTemplatesModalProps> = (
    props: SaveInMyTemplatesModalProps
): JSX.Element => {
    const {
        templateName,
        fromEmail,
        fromName,
        subject,
        isEmailInvalid,
        setTemplateName,
        setFromEmail,
        setFromName,
        setSubject,
    } = props;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { errors } = useSelector(getCampainCreatorStore);
    const templateNameInUseError = !!errors?.[CampaignErrorNames.TEMPLATE_NAME_IN_USE];
    const [invalidEmailError, setInvalidEmailError] = useState<boolean>(isEmailInvalid(fromEmail));

    const handleSetTemplateName = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
        setTemplateName(event.target.value);
        templateNameInUseError && dispatch(VerifyCampaign());
    };

    const handleSetFromName = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
        setFromName(event.target.value);
    };

    const handleSetFromEmail = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
        setFromEmail(event.target.value);
        setInvalidEmailError(isEmailInvalid(event.target.value));
    };

    const handleSetSubject = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
        setSubject(event.target.value);
    };

    return (
        <ContentWrapper>
            <BasicInput
                label={t('templatename')}
                defaultValue={templateName}
                onChange={handleSetTemplateName}
                error={templateNameInUseError}
                errorMessage={t('templatenameinuse')}
            />
            <BasicInput label={t('fromname')} defaultValue={fromName} onChange={handleSetFromName} />
            <BasicInput
                label={t('frommail')}
                defaultValue={fromEmail}
                onChange={handleSetFromEmail}
                error={invalidEmailError}
                errorMessage={t('emailinvalid')}
            />
            <BasicInput label={t('subject')} defaultValue={subject} onChange={handleSetSubject} />
        </ContentWrapper>
    );
};
